import React, { useState, useEffect } from "react";
import img2 from "../../image for geo project/2.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { IoPricetagOutline } from "react-icons/io5";
import { Swiper, SwiperSlide } from "swiper/react";
import { MdOutlineBedroomParent } from "react-icons/md";
import { TbContract } from "react-icons/tb";
import { FiLayout } from "react-icons/fi";
import { HiOutlineBuildingOffice2 } from "react-icons/hi2";
import { LuBath } from "react-icons/lu";
import { TfiRulerAlt } from "react-icons/tfi";
import { FaMobileAlt } from "react-icons/fa";
import { FaPhone } from "react-icons/fa";
import { SiWhatsapp } from "react-icons/si";
import { SlCalender } from "react-icons/sl";
import { AiOutlineFormatPainter } from "react-icons/ai";
import { LuTreePalm } from "react-icons/lu";
import { MdBalcony } from "react-icons/md";
import { GrElevator } from "react-icons/gr";
import { MdOutlinePool } from "react-icons/md";
import { RiParkingBoxLine } from "react-icons/ri";
import { HiOutlineHomeModern } from "react-icons/hi2";
import { TbSolarElectricity } from "react-icons/tb";
import { RiWaterFlashLine } from "react-icons/ri";
import { PiElevatorDuotone } from "react-icons/pi";
import { TbRulerMeasure } from "react-icons/tb";
import { TbRulerMeasure2 } from "react-icons/tb";
import { FaCheckCircle } from "react-icons/fa";
import { IoCloseCircle } from "react-icons/io5";
import { PiSolarPanel } from "react-icons/pi";
import { GiHotSurface } from "react-icons/gi";
import { FaPersonShelter } from "react-icons/fa6";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import { RiSofaLine } from "react-icons/ri";
import { FaCarSide } from "react-icons/fa";
import { FaCarTunnel } from "react-icons/fa6";
import { GiCarSeat } from "react-icons/gi";
import { RxCounterClockwiseClock } from "react-icons/rx";
import { IoMdColorFilter } from "react-icons/io";
import { FaGasPump } from "react-icons/fa";
import { PiEngine } from "react-icons/pi";
import { GiCarWheel } from "react-icons/gi";
import { GiCarKey } from "react-icons/gi";
import { GiGearStick } from "react-icons/gi";
import { BiCategoryAlt } from "react-icons/bi";
import { PiGpsFix } from "react-icons/pi";
import { FaBluetooth } from "react-icons/fa";
import { TbAirConditioning } from "react-icons/tb";
import { VscDashboard } from "react-icons/vsc";
import { MdOutlineTouchApp } from "react-icons/md";
import { GiAbstract021 } from "react-icons/gi";
import { FaCarOn } from "react-icons/fa6";
import ReactPlayer from 'react-player'
// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import "./styles.css";
import { Grid, IconButton, Modal, Tooltip, Typography } from "@mui/material";
import { GiDuration } from "react-icons/gi";

// import required modules
import { FreeMode, Navigation, Thumbs } from "swiper/modules";
import { MdOutlineSlowMotionVideo } from "react-icons/md";
import "react-circular-progressbar/dist/styles.css";

import { useTranslation } from "react-i18next";
import { useFetchData } from "../../hooks/useFetchData";
import { TestLanguage } from "../../hooks/testLanguage";
import { IoIosCall } from "react-icons/io";
import { RiWhatsappFill } from "react-icons/ri";
import { TfiEmail } from "react-icons/tfi";
const Drawercar = ({ point, isOpen, onClose, children }) => {
  const [showDiv, setShowDiv] = useState(false);

  const [open2, setOpen2] = React.useState(false);
  const url = `${process.env.REACT_APP_API_URL}carbyid/${point}`;
  const { data, isLoading, error } = useFetchData(url, "drawer2");
  const handleOpen = () => {
    setOpen2(true);

  };

  const handleClose = () => {
    console.log("Modal close clicked");
    setOpen2(false);
  };
  const handleClick = () => {
   
    const id =data.data.id
    setShowDiv((prev) => !prev);
    const formdata = new FormData()
    formdata.append("id",id)
     if (!showDiv){
  const postData = async () => {
  const response = await fetch('https://3dfinal.tanaghomtech.com/public/api/carview', {
    method: 'POST',
    body:formdata,
  });

  if (!response.ok) {
    throw new Error('Failed to post data');
  }

  return response.json();
};
postData();
     }
  };
  const videoList = data?.data?.medias?.filter((media) => media?.type === "video") || [];
  const [selectedVideo, setSelectedVideo] = useState(null);
  const handleVideoClick = (video) => {
    setSelectedVideo("http://3dfinal.tanaghomtech.com/storage/app/public/" + video?.link);
  };
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const { t } = useTranslation();


  console.log(data?.videos_count);
  const cardStyle = {
    width: "350px",
    height: "250px",
    padding: "20px",
    border: "1px solid #ddd",
    borderRadius: "12px",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    fontFamily: "Oswald,Cairo, sans-serif",
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "10px",
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    margin: "5px",
  };

  const iconStyle = {
    fontSize: "40px",
    color: "#333",
  };

  const labelStyle = {
    fontSize: "20px",
    fontWeight: "bold",
    marginTop: "8px",
  };

  const valueStyle = {
    fontSize: "16px",
    color: "gray",
    marginTop: "4px",
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
  };

  const direction = localStorage.getItem("lang") === "ar" ? "rtl" : "ltr";
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        right: isOpen ? 0 : "-700px",
        width: "700px",
        height: "100%",
        backgroundColor: "#fff",
        boxShadow: "-2px 0 5px rgba(0,0,0,0.3)",
        transition: "right 0.5s ease-in-out",
        zIndex: 1000,
        padding: "20px",
        overflowY: "auto",
        fontFamily: "Oswald,Cairo, sans-serif",
        fontWeight: "bolder",
      }}
    >
      <a style={{ cursor: "pointer" }} onClick={onClose}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          fill="#232324"
          class="bi bi-x-circle-fill"
          viewBox="0 0 16 16"
        >
          <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
        </svg>
      </a>

      {data?.data?.post.id && (
        <Grid spacing={2} sx={{ direction: direction }}>
          {/* <Grid item xs={6}>
            <Typography
              variant="h2"
              sx={{
                backgroundColor: "#FFF1CA",
                padding: "30px",
                borderRadius: "50%",
                width: "100px",
                height: "100px",

                fontWeight: "bold",
              }}
            >
              {data.data.post.post_reference}
            </Typography>
          </Grid> */}

          <Grid item xs={6}>
            <Typography
              variant="h4"
              sx={{
                mt: 2,
                mb: 2,
                boxShadow:
                  "rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px",
                padding: "8px",
                backgroundColor: "#f3efee",
                display: "inline-block",
                width: "auto",
                fontWeight: "bold",
                fontFamily: "oswald,cairo",
              }}
            >
              {TestLanguage(data?.data.offertype, "name")}{" "}
              {TestLanguage(data?.data.status, "name")}
            </Typography>
          </Grid>
        </Grid>
      )}
      <Swiper
        style={{
          "--swiper-navigation-color": "#fff",
          "--swiper-pagination-color": "#fff",
          marginTop: "16px",
        }}
        loop={true}
        spaceBetween={10}
        navigation={true}
        thumbs={{ swiper: thumbsSwiper }}
        modules={[FreeMode, Navigation, Thumbs]}
        className="mySwiper2"
      >
        {data?.images?.map((img, idx) => (
          <SwiperSlide>
            <img
              src={`http://3dfinal.tanaghomtech.com/storage/app/public/${img.link}`}
              style={{ height: "450px", borderRadius: "16px" }}
              className="w-100"
              alt={`Slide ${idx}`}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <Swiper
        onSwiper={setThumbsSwiper}
        loop={true}
        spaceBetween={10}
        slidesPerView={8}
        freeMode={true}
        watchSlidesProgress={true}
        modules={[FreeMode, Navigation, Thumbs]}
        className="mySwiper"
      >
        {data?.images?.map((img, idx) => (
          <SwiperSlide>
            <img
              src={`http://3dfinal.tanaghomtech.com/storage/app/public/${img.link}`}
              style={{ height: "80px", borderRadius: "8px" }}
              className="w-100"
              alt={`Slide ${idx}`}
            />
          </SwiperSlide>
        ))}
      </Swiper>

      <div
        style={{
          fontFamily: "Oswald,Cairo, sans-serif",
          direction: direction,
          fontWeight: "bolder",
        }}
      >
        {children}
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          direction: direction,
          fontWeight: "bolder",
        }}
      >
        <FontAwesomeIcon icon={faLocationDot} style={{ margin: "5px" }} />
        <h5>
          {TestLanguage(data?.data?.city, "name")}{" - "}
          {TestLanguage(data?.data?.region, "name")}{" - "}
          {TestLanguage(data?.data, "address")}
        </h5>
      </div>

      <div className="row">
        <h3
          style={{
            fontFamily: "Oswald,Cairo, sans-serif",
            marginTop: "50px",
            marginBottom: "20px",
            fontWeight: "bolder",
            direction: direction,
          }}
        >
          {t("drawerUnit.details")}
        </h3>
      </div>

      <div className="row animate-bottom2">
        <div style={{ display: "flex", alignItems: "center" }}>
          {data?.data?.made_year && (
            <div style={cardStyle}>
              <SlCalender style={iconStyle} />
              <div style={labelStyle}>{t("drawerUnit.made_year")}</div>
              <div style={valueStyle}>{data?.data?.made_year} </div>
            </div>
          )}
          {data?.data?.car_model_id && (
            <div style={cardStyle}>
              <FaCarSide style={iconStyle} />

              <div style={labelStyle}>{t("drawerUnit.car_model")}</div>
              <div style={valueStyle}>
                {TestLanguage(data?.data?.car_model, "name")}
              </div>
            </div>
          )}
          {data?.data?.car_submodel && (
            <div style={cardStyle}>
              <FaCarTunnel style={iconStyle} />
              <div style={labelStyle}>{t("drawerUnit.car_submodel")}</div>
              <div style={valueStyle}>{data?.data?.car_submodel} </div>
            </div>
          )}
          {data?.data?.price && (
            <div style={cardStyle}>
              <IoPricetagOutline style={iconStyle} />
              <div style={labelStyle}>{t("drawerUnit.Price")}</div>
              <div style={valueStyle}>{data?.data?.price}$</div>
            </div>
          )}
          {data?.data?.car_transmission_id && (
            <div style={cardStyle}>
              <GiGearStick style={iconStyle} />
              <div style={labelStyle}>{t("drawerUnit.car_transmission")}</div>
              <div style={valueStyle}>
                {TestLanguage(data?.data?.car_transmission, "name")}
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="row animate-bottom2">
        <div style={{ display: "flex", alignItems: "center" }}>
          {data?.data?.bath_count && (
            <div style={cardStyle}>
              <LuBath style={iconStyle} />
              <div style={labelStyle}>{t("drawerUnit.bathrooms")}</div>
              <div style={valueStyle}>{data?.data?.bath_count}</div>
            </div>
          )}
          {data?.data?.motor_counter && (
            <div style={cardStyle}>
              <RxCounterClockwiseClock style={iconStyle} />
              <div style={labelStyle}>{t("drawerUnit.motor_counter")}</div>
              <div style={valueStyle}>{data?.data?.motor_counter}</div>
            </div>
          )}

          {data?.data?.color_id && (
            <div style={cardStyle}>
              <IoMdColorFilter style={iconStyle} />
              <div style={labelStyle}>{t("AddCar.carscolors")}</div>
              <div style={valueStyle}>
                {TestLanguage(data?.data?.color, "name")}{" "}
              </div>
            </div>
          )}
          {data?.data?.petroltype && (
            <div style={cardStyle}>
              <FaGasPump style={iconStyle} />
              <div style={labelStyle}>{t("AddCar.carspetrols")}</div>
              <div style={valueStyle}>
                {TestLanguage(data?.data?.petroltype, "name")}
              </div>
            </div>
          )}

          {data?.data?.paintcondition && (
            <div style={cardStyle}>
              <AiOutlineFormatPainter style={iconStyle} />
              <div style={labelStyle}>{t("AddCar.carspaintcondition")}</div>
              <div style={valueStyle}>
                {TestLanguage(data?.data?.paintcondition, "name")}
              </div>
            </div>
          )}

          {data?.data?.carchairtype && (
            <div style={cardStyle}>
              <GiCarSeat style={iconStyle} />
              <div style={labelStyle}>{t("AddCar.carschairstypes")}</div>
              <div style={valueStyle}>
                {TestLanguage(data?.data?.carchairtype, "name")}
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="row"></div>
      <div className="row animate-bottom2">
        <div style={{ display: "flex", alignItems: "center" }}>
          {data?.data?.category && (
            <div style={cardStyle}>
              <BiCategoryAlt style={iconStyle} />
              <div style={labelStyle}>{t("AddCar.category")}</div>
              <div style={valueStyle}>
                {TestLanguage(data?.data?.category, "name")}
              </div>
            </div>
          )}
          {data?.data?.motorsize && (
            <div style={cardStyle}>
              <PiEngine style={iconStyle} />
              <div style={labelStyle}>{t("AddCar.motorsize")}</div>
              <div style={valueStyle}>{data?.data.motorsize} cc</div>
            </div>
          )}
          {data?.data?.motordrive && (
            <div style={cardStyle}>
              <GiCarWheel style={iconStyle} />
              <div style={labelStyle}>{t("AddCar.carsmotors")}</div>
              <div style={valueStyle}>
                {TestLanguage(data?.data?.motordrive, "name")}
              </div>
            </div>
          )}

          {data?.data?.rent && (
            <div style={cardStyle}>
              <GiDuration style={iconStyle} />
              <div style={labelStyle}>{t("AddUnit.rentduration")}</div>
              <div style={valueStyle}>
                {TestLanguage(data?.data.rent, "name")}
              </div>
            </div>
          )}

          {data?.data?.post.seller && (
            <div style={cardStyle}>
              <FaPersonShelter style={iconStyle} />
              <div style={labelStyle}>{t("drawerUnit.sellertype")}</div>
              <div style={valueStyle}>
                {TestLanguage(data?.data?.post.seller, "name")}
              </div>
            </div>
          )}
        </div>
      </div>

      <h3
        style={{
          fontFamily: "Oswald,Cairo, sans-serif",
          marginTop: "50px",
          marginBottom: "20px",
          fontWeight: "bolder",
          direction: direction,
        }}
      >
        {t("drawerUnit.detailsexpress")}
      </h3>
      <Grid sx={{ direction: t("directions.dir") }} container spacing={2}>
        <Grid size={4} item>
          <PiGpsFix size={25} />{" "}
          <span style={{ fontWeight: "300" }}>{t("AddCar.gps")}</span>{" "}
          {data?.data?.gps ? (
            <FaCheckCircle style={{ color: "green" }} />
          ) : (
            <IoCloseCircle style={{ color: "red" }} />
          )}
        </Grid>

        <Grid size={4} item>
          <FaBluetooth size={25} />{" "}
          <span style={{ fontWeight: "300" }}>{t("AddCar.bluetooth")}</span>{" "}
          {data?.data?.bluetooth ? (
            <FaCheckCircle style={{ color: "green" }} />
          ) : (
            <IoCloseCircle style={{ color: "red" }} />
          )}
        </Grid>

        <Grid size={4} item>
          <TbAirConditioning size={25} />{" "}
          <span style={{ fontWeight: "300" }}>{t("AddCar.aircondition")}</span>{" "}
          {data?.data?.aircondition ? (
            <FaCheckCircle style={{ color: "green" }} />
          ) : (
            <IoCloseCircle style={{ color: "red" }} />
          )}
        </Grid>

        <Grid size={4} item>
          <VscDashboard size={25} />
          <span style={{ fontWeight: "300" }}>{t("AddCar.cd")}</span>{" "}
          {data?.data?.cd ? (
            <FaCheckCircle style={{ color: "green" }} />
          ) : (
            <IoCloseCircle style={{ color: "red" }} />
          )}
        </Grid>

        <Grid size={4} item>
          <MdOutlineTouchApp size={25} />{" "}
          <span style={{ fontWeight: "300" }}>{t("AddCar.touchscreen")}</span>{" "}
          {data?.data?.touchscreen ? (
            <FaCheckCircle style={{ color: "green" }} />
          ) : (
            <IoCloseCircle style={{ color: "red" }} />
          )}
        </Grid>

        <Grid size={4} item>
          <GiAbstract021 size={25} />{" "}
          <span style={{ fontWeight: "300" }}>{t("AddCar.abs")}</span>{" "}
          {data?.data?.abs ? (
            <FaCheckCircle style={{ color: "green" }} />
          ) : (
            <IoCloseCircle style={{ color: "red" }} />
          )}
        </Grid>

        <Grid size={4} item>
          <FaCarOn size={25} />{" "}
          <span style={{ fontWeight: "300" }}>{t("AddCar.sunroof")}</span>{" "}
          {data?.data?.sunroof ? (
            <FaCheckCircle style={{ color: "green" }} />
          ) : (
            <IoCloseCircle style={{ color: "red" }} />
          )}
        </Grid>
      </Grid>

      {data?.videos_count !== 0 && (
        <div className="row" style={{ direction: direction }}>
          <h3
            style={{
              fontFamily: "Oswald,Cairo, sans-serif",
              marginTop: "50px",
              marginBottom: "20px",
              fontWeight: "bolder",
            }}
          >
            {t("drawerUnit.Media")}
          </h3>
          <div style={{ cursor: "pointer" }} onClick={() => { }}>
            <div
              onClick={handleOpen}
              style={{
                backgroundImage: `url(${img2})`,
                width: "200px",
                height: "200px",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                margin: "8px",
                borderRadius: "8px",
                direction: direction,
              }}
            >
              <MdOutlineSlowMotionVideo
                style={{
                  color: "white",
                  margin: "47px",
                  fontSize: "100px",
                  direction: direction,
                }}
              />
              <Modal open={open2} onClose={handleClose}>

                <Box
                  sx={{
                    ...style,
                    width: "90%",
                    maxWidth: "1200px",
                    display: "flex",
                    flexDirection: "row",
                    gap: 2,
                    padding: 2,
                    backgroundColor: "#fff",
                  }}
                >
                  <a
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      e.stopPropagation(); // ✅ very important
                      handleClose();
                    }}
                    role="button"
                    aria-label="Close modal"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      fill="#232324"
                      class="bi bi-x-circle-fill"
                      viewBox="0 0 16 16"
                    >
                      <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
                    </svg>
                  </a>
                  {/* Main video player */}
                  <Box sx={{ flex: 3 }}>
                    {selectedVideo ? (
                      <ReactPlayer
                        src={selectedVideo}
                        controls
                        width="100%"
                        height="500px"
                      />
                    ) : (
                      <p>No video selected</p>
                    )}
                  </Box>

                  {/* Small video list on the right */}
                  <Box sx={{ flex: 1, overflowY: "auto", maxHeight: "500px" }}>
                    {videoList?.map((video) => (
                      <Box
                        key={video.id}
                        sx={{
                          marginBottom: "10px",
                          cursor: "pointer",
                          border: selectedVideo === process.env.REACT_APP_IMAGE + video.link ? "2px solid #1976d2" : "1px solid #ccc",
                          borderRadius: "8px",
                          overflow: "hidden",
                        }}
                        onClick={() => handleVideoClick(video)}
                      >
                        <ReactPlayer
                          src={"http://3dfinal.tanaghomtech.com/storage/app/public/" + video.link}
                          controls={false}
                          width="100%"
                          height="100px"
                        />
                      </Box>
                    ))}
                  </Box>
                </Box>
              </Modal>
            </div>
            <h5
              style={{
                fontFamily: "Oswald,Cairo, sans-serif",
                paddingLeft: "8px",
                direction: direction,
              }}
            >
              {t("drawerUnit.ProjectVideoscar")}
            </h5>
            <p
              style={{
                fontFamily: "Oswald,Cairo, sans-serif",
                paddingLeft: "8px",
                direction: direction,
              }}
            >
              {data?.videos_count} {t("drawerUnit.videos")}
            </p>
          </div>
        </div>
      )}

      {data?.data?.post.id && (
        <div className="row" style={{ textAlign: "center" }}>
          <div className="col-md-12">
            <div className="circle-container">
              <h1 className="title">{data.data.post.post_reference}</h1>
              <p className="subtitle">{t("drawerUnit.adsnumber")}</p>
            </div>
          </div>
        </div>
      )}

      <h3
        style={{
          fontFamily: "Oswald,Cairo, sans-serif",
          marginTop: "50px",
          marginBottom: "20px",
          fontWeight: "bolder",
          direction: direction,
        }}
      >
        {t("drawerUnit.detailsconn")}
      </h3>
      <div className="row">
        <div
          style={{
            display: "flex",
            alignItems: "center",

            fontWeight: "bolder",
          }}
          className="col-md-2"
        >
          <Avatar
            onClick={handleClick}
            sx={{
              width: "80px",
              height: "80px",
              cursor: "pointer",
              transition: "transform 0.3s ease",
              "&:hover": { transform: "scale(1.05)" },
            }}
            alt={data?.data?.post.user.name}
            src={process.env.REACT_APP_IMAGE + data?.data?.post.user.image}
          />{" "}
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",

            fontWeight: "bolder",
          }}
          className="col-md-10"
        >
          {data?.data?.post.user.name}
          {/* <FaMobileAlt
            style={{
              backgroundColor: "#f3efee",
              margin: "5px",
              width: "50px",
              height: "50px",
              padding: "10px",
              borderRadius: "10px",
            }}
          /> */}
        </div>
        {showDiv && (
          <div
            style={{
              maxHeight: showDiv ? "200px" : "0px",
              opacity: showDiv ? 1 : 0,
              overflow: "hidden",
              transition: "max-height 0.5s ease, opacity 0.5s ease",
              // backgroundColor: '#e0e0e0',
              marginTop: "10px",
              padding: showDiv ? "10px" : "0px",
              borderRadius: "8px",
            }}
            className="row"
          >
            <div className="col-md-3">
              {" "}
              <IoIosCall size={22} /> {data?.data?.post.user.mobile}
            </div>
            <div className="col-md-3">
              {" "}
              {data?.data?.post.user.whatsapp ? (
                <RiWhatsappFill size={22} />
              ) : (
                ""
              )}
               <a
                href={`https://wa.me/${data?.data?.post.user.whatsapp}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{textDecoration:"none",color:"#333333"}}
              >
                {data?.data?.post.user.whatsapp
                  ? data?.data?.post.user.whatsapp
                  : ""}
              </a>
            </div>
            <div className="col-md-3">
              {" "}
              {data?.data?.post.user.email ? <TfiEmail size={22} /> : ""}{" "}
              {data?.data?.post.user.email ? data?.data?.post.user.email : ""}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Drawercar;
